import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "space-y-6 pb-8" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-y-6 gap-x-6" }
const _hoisted_4 = {
  key: 0,
  class: "absolute rounded-lg border border-red-lp-100 px-4 py-3 bg-red-lp-1300 text-red-lp-100 flex flex-row items-start",
  style: {"right":"-368px","top":"26px","width":"352px"}
}
const _hoisted_5 = { class: "text-14px" }
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" sudah terdaftar. Hapus atau ubah dengan Kecamatan lainnya ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectCity = _resolveComponent("SelectCity")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.$route.meta?.name,
    "custom-class": "px-0",
    fullPage: !_ctx.isEdit,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[15] || (_cache[15] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage,
    verticalSeparator: _ctx.isEdit,
    loading: _ctx.detailEntities.loading,
    error: !!_ctx.detailEntities.message,
    errorType: _ctx.detailEntities.message,
    onTryAgain: _ctx.fetchDetail
  }, _createSlots({
    "top-right": _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_LpButton, {
          "text-color": "white",
          customClass: "w-full py-2.5",
          title: "Simpan",
          onClick: _ctx.onSave,
          disabled: _ctx.isDisableForm
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    data: _withCtx(() => [
      _createVNode("div", {
        class: `px-4 ${_ctx.isEdit ? 'w-4/5' : 'w-3/5'}`
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: "Nama Kendala",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                  placeholder: "Contoh: Kebanjiran Area A",
                  isError: _ctx.error.errorName,
                  "onUpdate:isError": _cache[2] || (_cache[2] = ($event: any) => (_ctx.error.errorName = $event)),
                  minLength: "3",
                  showMaxLength: "",
                  maxLength: "20",
                  disabled: _ctx.isEdit
                }, null, 8, ["modelValue", "isError", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "3LC",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectCity, {
                  status: "active",
                  class: "mt-1.5",
                  placeholder: "Ketik atau pilih 3LC",
                  modelValue: _ctx.form.cityData,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.cityData = $event)),
                  keyName: "code",
                  onChange: _ctx.onChangeCity,
                  isError: _ctx.error.errorCityCode,
                  "onUpdate:isError": _cache[4] || (_cache[4] = ($event: any) => (_ctx.error.errorCityCode = $event)),
                  disabled: _ctx.isEdit
                }, null, 8, ["modelValue", "onChange", "isError", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Kecamatan",
              asterisk: "",
              class: "relative"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectSearch, {
                  class: "mt-1.5",
                  customDisplayAll: "Semua Kecamatan",
                  options: _ctx.listDistrict,
                  modelValue: _ctx.form.districtData,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.districtData = $event)),
                  isError: _ctx.error.errorDistrict,
                  "onUpdate:isError": _cache[6] || (_cache[6] = ($event: any) => (_ctx.error.errorDistrict = $event)),
                  errorDataShow: _ctx.error.districtData,
                  modalTitle: "Kota Asal",
                  keyName: "name",
                  keyValue: "code",
                  isLoading: _ctx.isLoadingDistrict,
                  placeholder: "Ketik atau pilih kecamatan",
                  onFocus: _ctx.fetchDistrict,
                  onFilter: _ctx.filterDistrict,
                  onRemove: _ctx.onRemoveDistrict,
                  isDisabled: !_ctx.form.cityData.code
                }, null, 8, ["options", "modelValue", "isError", "errorDataShow", "isLoading", "onFocus", "onFilter", "onRemove", "isDisabled"]),
                (_ctx.error.districts.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("span", _hoisted_5, [
                        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.error.districts), 1),
                        _hoisted_7
                      ]),
                      _createVNode(_component_Icons, {
                        name: "icon-x",
                        class: "w-12 ml-2 cursor-pointer",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.error.districts = ''))
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              class: "col-span-2",
              label: "Catatan",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.remarks,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.remarks = $event)),
                  type: "textarea",
                  isError: _ctx.error.errorRemarks,
                  "onUpdate:isError": _cache[9] || (_cache[9] = ($event: any) => (_ctx.error.errorRemarks = $event)),
                  placeholder: "Masukkan catatan kendala yang sedang terjadi",
                  minLength: "3",
                  showMaxLength: "",
                  maxLength: "200"
                }, null, 8, ["modelValue", "isError"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Tanggal Mulai",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.form.startDate,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.startDate = $event)),
                  class: "my-2",
                  maxDate: _ctx.isEdit? new Date() : _ctx.maxDate,
                  onSelected: _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.endDate = '')),
                  isError: _ctx.error.errorStartDate,
                  "onUpdate:isError": _cache[12] || (_cache[12] = ($event: any) => (_ctx.error.errorStartDate = $event))
                }, null, 8, ["modelValue", "maxDate", "isError"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Tanggal Berakhir",
              optional: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DatePicker, _mergeProps({
                  modelValue: _ctx.form.endDate,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.endDate = $event)),
                  class: "my-2"
                }, _ctx.endDateAttributes, {
                  isError: _ctx.error.errorEndDate,
                  "onUpdate:isError": _cache[14] || (_cache[14] = ($event: any) => (_ctx.error.errorEndDate = $event))
                }), null, 16, ["modelValue", "isError"])
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ]),
    _: 2
  }, [
    (_ctx.isEdit)
      ? {
          name: "sub-data",
          fn: _withCtx(() => [
            _createVNode(_component_DataWrapper, { label: "Status" }, {
              default: _withCtx(() => [
                _createVNode(_component_ChipsV2, {
                  label: _ctx.detailData.statusData
                }, null, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Tanggal Dibuat",
              value: _ctx.formatDate(_ctx.form.createdAt),
              caption: _ctx.form.createdBy
            }, null, 8, ["value", "caption"]),
            _createVNode(_component_DataWrapper, {
              label: "Tanggal Diubah",
              value: _ctx.formatDate(_ctx.form.updatedAt),
              caption: _ctx.form.updatedBy
            }, null, 8, ["value", "caption"])
          ])
        }
      : undefined
  ]), 1032, ["onBack", "title", "fullPage", "leave-page-confirmation", "onLeavePage", "verticalSeparator", "loading", "error", "errorType", "onTryAgain"]))
}